// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2qS--","author":"Table_author__1rEzc","authorImage":"Table_authorImage__1oBLB","unreadRow":"Table_unreadRow__XV99u"};